{
  "main": {
    "title": "Disponibilità",
    "nazaj": "Indietro"
  },
  "nav": {
    "vnos": "Inserimento",
    "zapisi": "Registrazioni"
  },
  "labelsR": {
    "datum": "data",
    "uraOd": "ora di inizio",
    "uraDo": "ora di fine",
    "UrejanjeZapisa": "Modifica Registrazione",
    "namenVnosa": "Seleziona il tipo di volo",
    "namenMotorno": "volo",
    "namenJadralno": "volo a vela",
    "namenVleka": "traino",
    "registracija": "Registrazione",
    "filtriraj": "Filtra",
    "isci": "Cerca e seleziona",
    "izberi": "Premi Invio per selezionare",
    "odstrani": "Premi Invio per rimuovere",
    "neObstaja": "Non riesco a trovare ciò che stai cercando",
    "izbrano": "Selezionato",
    "praznaLista": "Nessuna imbarcazione da visualizzare"

  },
  "obvestila": {
    "casVnosa": "Correggi gli orari! L'ora di inizio non può essere posteriore all'ora di fine.",
    "praznoPlovilo": "Non hai selezionato alcuna imbarcazione. Seleziona un'imbarcazione.",
    "prazenDatum": "La data di inserimento è vuota! Seleziona la data desiderata.",
    "opomba": "Nota"
  },
  "buttons": {
    "vnesiZapis": "Aggiungi Inserimento",
    "urediZapis": "Aggiorna",
    "brisiZapis": "Elimina",
    "brisiIzbiro": "Elimina"
  }
}